var map = {
	"./DAB-Profile-Alexander.png": "27b8",
	"./DAB-Profile-Andreas-Gregori.png": "a4d6",
	"./DAB-Profile-Bhargav-Marepally.png": "a032",
	"./DAB-Profile-Ken-Sommer.png": "4153",
	"./DAB-Profile-Prabhu-Antony.png": "42bf",
	"./DAB-Profile-Prashant.png": "9d82",
	"./DAB-Profile-Rudiantara.png": "24ed",
	"./DAB-Profile-Subir.png": "c290",
	"./Wharton-logo.png": "1745",
	"./logo-GSS.png": "f1e8",
	"./logo-barclays.png": "fa6d",
	"./logo-citigroup.png": "481b",
	"./logo-forbes.png": "4c46",
	"./logo-indosat-ooredoo.png": "62fc",
	"./logo-linus-ventures.png": "8b7a",
	"./logo-mercedespay.png": "8182",
	"./logo-northstar.png": "a9b4",
	"./logo-reliance.png": "046b",
	"./logo-settlucas.png": "42f6",
	"./logo-stonebridge.png": "30a8",
	"./logo-visa.png": "c29e",
	"./rocket_internet.png": "91b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "506e";